<script lang="ts" setup>
import { ErrorLayout } from '@app/customer/Layouts';

defineProps<{
  status: string | number;
  requestId?: string;
}>();
</script>

<template>
  <ErrorLayout
    :status="status"
    title="Oops. Something went wrong!"
  >
    <p>
      The <span class="font-semibold">Returnless development team</span> has been informed of this error message to
      prevent it in the future.
    </p>
    <p class="font-mono text-slate-600">
      Error code: {{ status }}
    </p>
    <div class="font-mono text-slate-400">
      Request ID
      <p class="text-xs">
        {{ requestId }}
      </p>
    </div>
  </ErrorLayout>
</template>
